import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FaPlay, FaCode,FaEye } from 'react-icons/fa';
import Fade from 'react-reveal/Fade';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import placeholder from '../../../assets/png/placeholder.png';
import './SingleProject.css';
// import stylesheet if you're not already using CSS @import


function SingleProject({ id, name, desc, tags, code, demo, image, theme, images }) {
	const [isOpen,setIsOpen]=useState(false);
	   const [photoIndex, setPhotoIndex] = useState(0);
	const dde=()=>{
	 setIsOpen(true);
  }
    const useStyles = makeStyles((t) => ({
        iconBtn: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: 50,
            border: `2px solid ${theme.secondary}`,
            color: theme.primary,
            transition: 'all 0.2s',
            '&:hover': {
                backgroundColor: theme.secondary,
                color: theme.primary,
                transform: 'scale(1.1)',
                border: `2px solid ${theme.secondary}`,
            },
        },
        icon: {
            fontSize: '1.1rem',
            transition: 'all 0.2s',
            '&:hover': {},
        },
    }));

    const classes = useStyles();

    return (
        <Fade bottom>
            <div
                key={id}
                className='singleProject'
                style={{ backgroundColor: theme.primary400 }}
            >
			{isOpen && (
          <Lightbox
		    imageTitle={name}
			zoomInLabel="Zoomer"
			closeLabel="fermer"
			discourageDownloads={false}
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpen(false )}
			onMovePrevRequest={() =>
			  setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
			  setPhotoIndex((photoIndex + 1) % images.length)
            }
          />
        )}
                <div className='projectContent'>
                    <h2
                        id={name.replace(' ', '-').toLowerCase()}
                        style={{ color: "black" }}
                    >
                        {name}
                    </h2>
                    <img src={image ? image : placeholder} alt={name} />
                    <div className='project--showcaseBtn'>
                        <button
                            onClick={dde}
                            target='_blank'
                            rel='noreferrer'
                            className={classes.iconBtn}
                            aria-labelledby={`${name
                                .replace(' ', '-')
                                .toLowerCase()} ${name
                                .replace(' ', '-')
                                .toLowerCase()}-demo`}
                        >
                            <FaPlay
                                id={`${name
                                    .replace(' ', '-')
                                    .toLowerCase()}-demo`}
                                className={classes.icon}
                                aria-label='Demo'
                            />
                        </button>
                        
                    </div>
                </div>
                <p
                    className='project--desc'
                    style={{
                        background: theme.secondary,
                        color: theme.tertiary,
                    }}
                >
                    {desc}
                </p>
                <div
                    className='project--lang'
                    style={{
                        background: theme.secondary,
                        color: theme.tertiary80,
                    }}
                >
                    {tags.split(',').map((tag, id) => (
						  <span key={id} style={{ marginRight: '8px', color: 'white' }}>
							{tag}
						  </span>
						))}
                </div>
            </div>
        </Fade>
    );
}

export default SingleProject;
